<div
  class="buttonContainer"
  *ngIf="buttonIsVisible"
>
  <button
    class="btn btn-log btn-sm"
    (click)="onClickHandler($event)"
  >
    Выход из группы
  </button>
</div>
